import InteractiveShop from './ui/main/InteractiveShop';
import useSetBackground from './model/hooks/useLoadBackground';
import { interactiveShopSegment } from './model/state-manager/interactiveShopSegment';

export default InteractiveShop;

export { useSetBackground, interactiveShopSegment };
